import create from './create';
import remove from './remove';
import sendMessage from './sendMessage';
import subscribeList from './subscribeList';
import update from './update';

export default { create, remove, sendMessage, subscribeList, update };
